export const ObjectErrorPopup = ({ title = '', message = '' }) => {
  application.utils.showErrorPopup(title, message);
};